
function AdminTransactionManagement() {
    let transactionManagement = [
        {
            name: "Transaction Management",
            icon: "Wallet-management",
            logoName: "MyAccounts",
            // flag: "voucherRequired",
            displayService: "adminTransactionManagement",
            items: [],
        },
    ];

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/AdminTransaction-Management",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "DASHBOARD",
            },
        ];

        return dashboardArr;
    };

  
    const adminTransaction = () => {
        const TransactionArr = [
            {
                path: "/index/AdminTransaction",
                name: "Transaction",
                icon: "WalletManagement",
                logoName: "wallet transaction",
                flag: "TRANSACTION"
                // flag: "isProfileSetting",
            },
        ];
        return TransactionArr;

    }
    const adminRefund = () => {
        const RefundArr = [
            {
                path: "/index/AdminRefund",
                name: "Refund",
                icon: "cash_Lifting",
                logoName: "cash_Lifting",
                flag: "REFUND"
                // flag: "isProfileSetting",
            },
        ];
        return RefundArr;
    };

    let a = dashboard();
    // let b = walletManagementSub();
    let b = adminTransaction()

    let c = adminRefund();

    transactionManagement[0].items = [...a, ...b, ...c];

    return transactionManagement;
}

export default AdminTransactionManagement;
